import React, {useState} from 'react';
import {
    Container,
    Grid,
    Button,
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import TextField from "@material-ui/core/TextField";
import {
    Box, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    TablePagination, Typography
} from "@mui/material";
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from "@material-ui/icons/Search";
import {APP_STATUS, APP_STATUS_VERBOSE, RATING_TYPE_VERBOSE} from "../../../utils/constants";

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
    },
    addButton: {
        marginBottom: theme.spacing(2),
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        },
    },
    tableHeaderCell: {
        textAlign:'center !important',
        fontSize: '17px',
        fontWeight: 500,
    },
    tableCell: {
        color: '#ED6628',
        textAlign:'center !important',
    },
    actionButton: {
        color: '#fff',
        borderRadius: '20px',
        fontSize: '13px',
        padding: '6px 12px',
        minWidth:'140px',
        marginRight: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            padding: '0px 20px',
            borderRadius: '10px',
        },
    },
    summaryActionButton: {
        background: "#00205F",
        color: '#fff',
        borderRadius: '15px',
        fontSize: '13px',
        padding: '6px 12px',
        marginRight: theme.spacing(1),
        minWidth:'130px',
        '&:hover': {
            background: "#00205F",        },
        [theme.breakpoints.down('sm')]: {
            padding: '11px 30px',
            borderRadius: '10px',
        },

    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: '32px !important',
        },
    },
    searchContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    searchInput: {
        marginLeft: theme.spacing(1),
        width: '300px',
    },

}));

const RatedProgramsList = ({ data, actions, options }) => {
    const classes = useStyles();
    const { ratingPrograms } = data;
    const { createProgramAction, removeProgramAction, addProgramInfoAction, viewProgramAction, viewFullReportAction } = actions;

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [programToDelete, setProgramToDelete] = useState(null);

    const [searchText, setSearchText] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleCreateProgram = () => {
        if (createProgramAction) {
            createProgramAction();
        }
    };

    const handleViewProgram = (programId, program_info, program_state, rating_type) => {
        if (!program_info) {
            addProgramInfoAction(programId, rating_type);
        }
        else if (viewProgramAction) {
            viewProgramAction(programId, program_state, rating_type);
        }
    };

    const handleViewFullReport = (programId, program_payment_state, program_state, rating_type) => {
        if (viewFullReportAction) {
            viewFullReportAction(programId, program_payment_state, program_state, rating_type);
        }
    };

    const handleDeleteProgram = (programId) => {
        setProgramToDelete(programId);
        setDeleteDialogOpen(true);
    };

    const handleConfirmDelete = () => {
        if (removeProgramAction && programToDelete) {
            removeProgramAction(programToDelete);
        }
        setDeleteDialogOpen(false);
        setProgramToDelete(null);
    };

    const handleCancelDelete = () => {
        setDeleteDialogOpen(false);
        setProgramToDelete(null);
    };

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
        setPage(0); // Reset to first page when search changes
    };

    const handleSearchClear = () => {
        setSearchText('');
        setPage(0);
    };

    const escapeRegExp = (value) => {
        return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    };

    const filteredPrograms = ratingPrograms.filter((program) => {
        const regex = new RegExp(escapeRegExp(searchText), 'i');
        return (
            regex.test(program.application_id) ||
            regex.test(program.programInfo ? program.programInfo.program_name : '') ||
            regex.test(program.app_status_v3)
        );
    });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const date_options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    return (
        <Container className={classes.container} maxWidth={false}>
            <Typography variant="h3" sx={{ textAlign: "center", marginBottom: 2, marginTop:{xs:'55px', sm:'40px'} }} className={classes.title}>
                Your Program Reports
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    fontSize: "1.2rem",
                    textAlign: "center",
                    marginBottom: 4,
                    maxWidth: "80%",
                    color: "#474747",
                    marginLeft:'180px',
                }}
            >
                The following is a list of your programs that have undergone alignment. You can view your available reports by clicking <strong>ACCESS REPORT</strong>. If you wish to align a new program, click <strong> ALIGN A PROGRAM </strong>at the top.            </Typography>
            <Box display={'flex'} alignItems="center"  mb={2} sx={{justifyContent:{sm:"flex-end", xs:'center'}}}>
                <Button
                    startIcon={<AddIcon />}
                    variant="contained"
                    color="primary"
                    className={classes.addButton}
                    onClick={handleCreateProgram}
                >
                    ALIGN A PROGRAM
                </Button>
                {/*<div className={classes.searchContainer}>*/}
                {/*    <TextField*/}
                {/*        variant="outlined"*/}
                {/*        value={searchText}*/}
                {/*        onChange={handleSearchChange}*/}
                {/*        placeholder="Search…"*/}
                {/*        className={classes.searchInput}*/}
                {/*        InputProps={{*/}
                {/*            startAdornment: <SearchIcon fontSize="small" />,*/}
                {/*            endAdornment: (*/}
                {/*                <IconButton*/}
                {/*                    title="Clear"*/}
                {/*                    aria-label="Clear"*/}
                {/*                    size="small"*/}
                {/*                    style={{ visibility: searchText ? 'visible' : 'hidden' }}*/}
                {/*                    onClick={handleSearchClear}*/}
                {/*                >*/}
                {/*                    <ClearIcon fontSize="small" />*/}
                {/*                </IconButton>*/}
                {/*            ),*/}
                {/*        }}*/}
                {/*    />*/}
                {/*</div>*/}
            </Box>
            <TableContainer component={Paper} style={{backgroundColor:'#fff'}}>
                <Table aria-label="programs table">
                    <TableHead>
                        <TableRow>
                            <TableCell  style={{textAlign:'center !important'}} className={classes.tableHeaderCell}>Program ID</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Program Title</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Report Type</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Submission Date</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Status</TableCell>
                            <TableCell className={classes.tableHeaderCell}>Reports</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredPrograms.length > 0 ? (
                            filteredPrograms
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((program) => (
                                    <TableRow key={program.application_id}>
                                        <TableCell className={classes.tableCell}>{program.application_id}</TableCell>
                                        <TableCell className={classes.tableCell}>{program.programInfo ? program.programInfo.program_name : ''}</TableCell>
                                        <TableCell className={classes.tableCell}>{RATING_TYPE_VERBOSE[program.rating_type]}</TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {(new Date(program.submission_time)).toLocaleDateString(undefined, date_options)}
                                        </TableCell>
                                        <TableCell className={classes.tableCell}>
                                            {
                                                program.app_status === APP_STATUS.WITHDRAWN ||
                                                program.app_status === APP_STATUS.REJECTED ||
                                                program.app_status === APP_STATUS.HALTED_COLLECT_DATA ||
                                                program.app_status === APP_STATUS.HALTED_PROCESS_DATA ||
                                                program.app_status === APP_STATUS.HALTED_REPORT
                                                ? APP_STATUS_VERBOSE[APP_STATUS.PROGRAM_SUMMARY_REPORT_HALTED]
                                                : APP_STATUS_VERBOSE[program.app_status_v3]
                                            }
                                        </TableCell>
                                        <TableCell>
                                            <Box display="flex" gap={2} sx={{flexDirection:{xs:'column', sm:'row'}}}>
                                                <Button
                                                    className={classes.summaryActionButton}
                                                    variant="contained"
                                                    disabled={program.programInfo && program.app_status_v3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED}
                                                    onClick={() => handleViewProgram(program.application_id, !!program.programInfo, program.app_status_v3, program.rating_type)}
                                                >
                                                    {program.programInfo ? 'Access Report' : 'Add Program Info'}
                                                </Button>
                                                {/*<Button*/}
                                                {/*    className={classes.actionButton}*/}
                                                {/*    variant="contained"*/}
                                                {/*    color="secondary"*/}
                                                {/*    disabled={program.app_status_v3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED}*/}
                                                {/*    onClick={() =>*/}
                                                {/*        handleViewFullReport(program.application_id, program.payment_status_v3, program.app_status_v3, program.rating_type)*/}
                                                {/*    }*/}
                                                {/*    style={{*/}
                                                {/*        background:*/}
                                                {/*            program.payment_status_v3 === APP_STATUS.COMPLETED ? "#008000" : "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%)",*/}
                                                {/*        "&:hover": {*/}
                                                {/*            background:*/}
                                                {/*                program.payment_status_v3 === APP_STATUS.COMPLETED ? "#008000" : "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%)",*/}
                                                {/*        },*/}
                                                {/*        color:*/}
                                                {/*            program.payment_status_v3 === APP_STATUS.COMPLETED ? "#fff" : "#c1bfbf",*/}
                                                {/*    }}*/}
                                                {/*>*/}
                                                {/*    {program.payment_status_v3 === APP_STATUS.COMPLETED ? 'Full Report Available' : 'Purchase Full Report'}*/}
                                                {/*</Button>*/}
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    No programs found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredPrograms.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <Dialog
                open={deleteDialogOpen}
                onClose={handleCancelDelete}
            >
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this program?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmDelete} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

export default RatedProgramsList;